import { render, staticRenderFns } from "./Forma28Forma.vue?vue&type=template&id=208a949c&scoped=true&"
import script from "./Forma28Forma.vue?vue&type=script&lang=js&"
export * from "./Forma28Forma.vue?vue&type=script&lang=js&"
import style1 from "./Forma28Forma.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208a949c",
  null
  
)

export default component.exports